/**
 * Only allow http(s) URLs into href/src. Anything else —
 * "javascript:alert(1)", "data:text/html,…", "vbscript:…" — returns
 * null so the caller renders no link at all. Database values are
 * user-controlled (content editors paste them), so treat every URL
 * that comes from the API as untrusted markup.
 */
export function safeHttpUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  try {
    const u = new URL(raw);
    if (u.protocol === 'https:' || u.protocol === 'http:') return u.href;
    return null;
  } catch {
    return null;
  }
}
